export class GcpCredentialProfileInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetServiceAccountEmail",
            "baseName": "targetServiceAccountEmail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpCredentialProfileInput.attributeTypeMap;
    }
    constructor() {
    }
}
